import axios from 'axios';
import { API_HOST } from '../constants/constants';
export const getOrders = async (orderId, token, userID) => {
  const apiURL =  API_HOST + (orderId ? '/orders/' + orderId : '/orders');
  try {
    const { data } = await axios.get(apiURL,{
      headers: {
        'Authorization': 'Bearer '+token
      }
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
